import { CallChaining, FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';
import MPCode from './MPCode.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.String,
    widget: 'MPCode',
    multi: false
  })
)
export class DetailStringMPCodeFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(MPCode);
    return this;
  }

  @Widget.Reactive()
  imgsrc = '';

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  protected async mountedProcess() {
    const dpr = window.devicePixelRatio;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    const width = 250;
    const height = 354;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(dpr, dpr);

    let src = '';
    let title = '';
    const invitationCode = [
      // F2B
      'deli.aries.seller.DeliAriesSellerExhibitionInvitationQrCode',
      'deli.aries.platform.DeliAriesPlatformExhibitionInvitationQrCode',
      'deli.aries.merchant.DeliAriesMerchantExhibitionInvitationQrCode',
      // B2b
      'deli.aries.exhibition.DeliAriesExhibitionInvitationQrCode'
    ].find((f) => f === this.field.model);

    const shareQRCode = [
      // F2B
      'deli.aries.merchant.DeliAriesMerchantExhibitionSignInQrCode',
      'deli.aries.seller.DeliAriesSellerExhibitionSignInQrCode',
      'deli.aries.platform.DeliAriesPlatformExhibitionSignInQrCode',
      // B2b
      'deli.aries.exhibition.DeliAriesExhibitionSignInQrCode'
    ].find((f) => f === this.field.model);
    switch (this.field.model) {
      case 'deli.aries.merchant.DeliAriesMerchantInvitationStoreQrCode':
        // eslint-disable-next-line no-case-declarations
        const { code, userId, name } = this.formData;
        if (!userId) {
          OioNotification.error('未获取到经销商信息');
          return;
        }
        // eslint-disable-next-line no-case-declarations
        const params = {
          page: 'pages/public/register/register',
          scene: `a=${code}&b=${userId}`,
          check_path: false,
          env_version: this.getEnv()
        };

        // eslint-disable-next-line no-case-declarations
        const bufferStr = await this.getMiniCode(params);
        src = `data:image/png;base64,${this.arrayBufferToBase64(bufferStr)}`;
        // title = name as string;
        break;
      case shareQRCode:
        src = `data:image/png;base64,${this.formData.signInCode}`;
        title = '签到码';
        break;
      case invitationCode:
        src = `data:image/png;base64,${this.formData.invitationCode}`;
        title = '邀请码';
        break;
      case 'deli.aries.merchant.DeliAriesMerchantLivestreamShareQRCode':
        src = `data:image/png;base64,${this.formData.shareQRCode}`;
        title = '分享码';
        break;
    }

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = '#000000';
    ctx.font = "18px '微软雅黑'";
    ctx.textAlign = 'center';
    ctx.fillText(title, width / 2, 25);
    ctx.font = "14px '微软雅黑'";
    this.wrapText(ctx, this.formData.name, width / 2, 316, 180, 19);

    const img = new Image();
    img.src = src;
    img.width = 250;
    img.height = 250;

    img.onload = () => {
      ctx.drawImage(img, 0, 44, img.width, img.height);
      setTimeout(() => {
        this.imgsrc = canvas.toDataURL('image/png');
      }, 200);
    };

    (document.querySelectorAll('.ant-modal')[0] as HTMLElement).style.width = '520px !important';
  }

  // 目前该已改为使用后端的
  getEnv() {
    return 'develop';
    // return 'trial';
    // return 'release';
  }

  async getMiniCode(params) {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify(params);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      responseType: 'arraybuffer'
    };

    const res = await fetch(`${location.origin}/pamirs/vxApp/queryVxAppCode`, requestOptions);
    const text = await res.arrayBuffer();

    return text;
  }

  arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  wrapText(canvas, text, x, y, maxWidth, lineHeight) {
    // 对入参的类型进行检测
    if (typeof text !== 'string' || typeof x !== 'number' || typeof y !== 'number') {
      return;
    }
    // 如果最大宽度未定义 默认为300px
    if (typeof maxWidth === 'undefined') {
      maxWidth = (canvas && canvas.width) || 300;
    }
    // 如果行高未定义 则定义为检测画布文本的行高或html页面的默认行高
    if (typeof lineHeight === 'undefined') {
      lineHeight =
        (canvas.canvas && parseInt(window.getComputedStyle(canvas.canvas).lineHeight, 10)) ||
        parseInt(window.getComputedStyle(document.body).lineHeight, 10);
    }
    const arrText = text.split('');
    let line = '';
    for (let n = 0; n < arrText.length; n++) {
      // 每个循环累加字符
      const testLine = line + arrText[n];
      // 检测累加字符 获取累加字符的高度和宽度
      const metrics = canvas.measureText(testLine);
      const testWidth = metrics.width;
      // 如果累加字符的宽度大于定义的绘制文本最大宽度 则绘制累加字符的文本 并且设置换行间距再次进行绘制
      if (testWidth > maxWidth && n > 0) {
        canvas.fillText(line, x, y);
        line = arrText[n];
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    canvas.fillText(line, x, y);
  }
}
